export const columns: any = [
  {
    title: 'select-all-btn',
    colSize: '3',
    sortable: false,
    active: false,
    col: 'select-btn'
  },
  {
    title: 'Attribute',
    colSize: '11',
    sortable: false,
    sort: 'desc',
    active: false,
    col: 'name',
  },
  {
    title: 'Description',
    colSize: '21',
    sortable: false,
    active: false,
    col: 'description'
  },
];
